import React, { createContext, useContext } from 'react'

import useFeatureFlag from 'hooks/useFeatureFlag'
import featureFlags from 'utils/featureFlags'

export interface FeatureFlagContextInterface {
    shortApp?: boolean
    newPowersportsApp?: boolean
    selfServiceManagement?: boolean
    leadsPage?: boolean
    webAppLoyaltyDashboard?: boolean
    customerEligibilityEnabledForAutoApps?: boolean
    payOff10Days?: boolean
    newWtdPath?: boolean
    flatCancel?: boolean
    documentViewerForStips?: boolean
    dealTermsTable?: boolean
    dealTermsTableFiltering?: boolean
    showNewSafeCheckPage?: boolean
    showFlexLink?: boolean
    dynamicPricing?: boolean
    tradeInAdjustment?: boolean
    returnCustomerPsApp2?: boolean
}

export const FeatureFlagContext =
    createContext<FeatureFlagContextInterface | null>(null)

interface FeatureFlagContextProviderProps {
    children: React.ReactNode
}

function FeatureFlagContextProvider(props: FeatureFlagContextProviderProps) {
    const { children } = props
    const shortApp = useFeatureFlag(featureFlags.shortApp)
    const newPowersportsApp = useFeatureFlag(featureFlags.newPowersportsApp)
    const showFlexLink = useFeatureFlag(featureFlags.showFlexLink)

    const selfServiceManagement = useFeatureFlag(
        featureFlags.selfServiceManagement,
    )

    const leadsPage = useFeatureFlag(featureFlags.leadsPage)

    const webAppLoyaltyDashboard = useFeatureFlag(
        featureFlags.webAppLoyaltyDashboard,
    )

    const customerEligibilityEnabledForAutoApps = useFeatureFlag(
        featureFlags.customerEligibilityEnabledForAutoApps,
    )

    const payOff10Days = useFeatureFlag(featureFlags.payOff10Days)
    const newWtdPath = useFeatureFlag(featureFlags.newWtdPath)
    const flatCancel = useFeatureFlag(featureFlags.flatCancel)

    const documentViewerForStips = useFeatureFlag(
        featureFlags.documentViewerForStips,
    )

    const dealTermsTable = useFeatureFlag(featureFlags.dealTermsTable)

    const dealTermsTableFiltering = useFeatureFlag(
        featureFlags.dealTermsTableFiltering,
    )

    const showNewSafeCheckPage = useFeatureFlag(
        featureFlags.showNewSafeCheckPage,
    )

    const dynamicPricing = useFeatureFlag(featureFlags.dynamicPricing)
    const tradeInAdjustment = useFeatureFlag(featureFlags.tradeInAdjustment)

    const returnCustomerPsApp2 = useFeatureFlag(
        featureFlags.returnCustomerPsApp2,
    )

    const ctx = React.useMemo(
        () => ({
            shortApp,
            newPowersportsApp,
            selfServiceManagement,
            leadsPage,
            webAppLoyaltyDashboard,
            customerEligibilityEnabledForAutoApps,
            payOff10Days,
            newWtdPath,
            flatCancel,
            documentViewerForStips,
            dealTermsTable,
            dealTermsTableFiltering,
            showNewSafeCheckPage,
            showFlexLink,
            dynamicPricing,
            tradeInAdjustment,
            returnCustomerPsApp2,
        }),
        [
            shortApp,
            newPowersportsApp,
            selfServiceManagement,
            leadsPage,
            webAppLoyaltyDashboard,
            customerEligibilityEnabledForAutoApps,
            payOff10Days,
            newWtdPath,
            flatCancel,
            documentViewerForStips,
            dealTermsTable,
            dealTermsTableFiltering,
            showNewSafeCheckPage,
            showFlexLink,
            dynamicPricing,
            tradeInAdjustment,
            returnCustomerPsApp2,
        ],
    )

    return (
        <FeatureFlagContext.Provider value={ctx}>
            {children}
        </FeatureFlagContext.Provider>
    )
}

export default FeatureFlagContextProvider
export const useFeatureFlagContext = () => useContext(FeatureFlagContext)
